var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-pagination',{attrs:{"length":_vm.pages,"prev-icon":"mdi-menu-left","next-icon":"mdi-menu-right"},on:{"input":_vm.emitPageValue},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})
}
var staticRenderFns = []

export { render, staticRenderFns }